import React, { Component } from 'react';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class LineChart extends Component {
  constructor(props) {
    super(props)

    
  }
  componentDidMount() {
    this.renderArea()
  }
  componentWillReceiveProps(nextProps){
    if((!typeof(nextProps.lineChartChildComponen)=='object') || (nextProps.lineChartChildComponen==null)){
      this.renderArea(nextProps)
    }
    
  }

  componentDidUpdate() {
    // this.renderArea()
  }

  renderArea(nextProps){
    var { mainDivId,id,yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,strokeColor,lineStyle,isGroupBar,groupIndex,curveStyle,type,yAxisData,
          dataLabels,marker,tooltip,name,showLineChartTooltip,hideLineChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,gridLineYAxis } =nextProps || this.props;
    curveStyle=(curveStyle!=undefined || curveStyle!=null) ? curveStyle : 'curveLinear';
    const { height } = svgDimensions;
    var chartHeight=this.props.svgDimensions.height-margins.top-margins.bottom;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((xAxisScale.labels && xAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((xAxisScale.labels && xAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((xAxisScale.labels && xAxisScale.labels.postfix) || '');

    var curveStyle = 'curveLinear';
    if(type=='verticalspline'){
        curveStyle = 'curveMonotoneX';
    }
    var preparedData=[];
    yAxisData.forEach(function(d,index){
      preparedData.push({
        yAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
        xAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["data"]:data[index]
      });
    });
    var fillColor=(lineStyle.fillColor ? lineStyle.fillColor : strokeColor);
    var strokeOpacity=(lineStyle.strokeOpacity ? lineStyle.strokeOpacity : 1);
    var strokeWidth=(lineStyle.strokeWidth ? lineStyle.strokeWidth : 2);
    var valueline = d3.line()
    .curve(d3[curveStyle])
    .y(function(d) { return yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2);  })
    .x(function(d) { return xAxisScale.scale(d.xAxisValue);  });
    d3.selectAll('#LineChartContainer_'+this.props.id).selectAll('*').remove();
    d3.selectAll('#LineChartContainer_'+this.props.id)
    .append("path")
    .data([preparedData])
    .style("fill-opacity",0)
    .style("stroke-opacity",strokeOpacity)
    .attr("stroke",fillColor)
    .attr("stroke-width",strokeWidth)
    .attr("class", "Line")
    .attr("d", valueline);

    var that=this;
   
    //CBT:This is for marker
    var globalTooltipShowLine=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.showLine || false ) : false;
    var globalTooltipCategory=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.category || '' ) : '';
    var symbol=marker.symbol || 'circle';
    var fillColorMarker=(marker.fillColor!=undefined && marker.fillColor !=null) ? marker.fillColor :'transparent';
    var strokeColorMarker=(marker.strokeColor!=undefined && marker.strokeColor !=null) ? marker.strokeColor :'transparent';
    var strokeWidthMarker=(marker.strokeWidth!=undefined && marker.strokeWidth !=null) ? marker.strokeWidth :"0px";
    var radius=marker.radius || 0;
    var hilightColorMarker=(marker.hilightColor!=undefined && marker.hilightColor !=null) ? marker.hilightColor : fillColorMarker;
    var hilightStrokeColorMarker=(marker.hilightStrokeColor!=undefined && marker.hilightStrokeColor !=null) ? marker.hilightStrokeColor : strokeColorMarker;
    var hilightStrokeWidthMarker=(marker.hilightStrokeWidth!=undefined && marker.hilightStrokeWidth !=null) ? marker.hilightStrokeWidth : strokeWidthMarker;
    var hilightRadius=marker.hilightRadius || radius;
    if(symbol=='circle'){
      d3.selectAll("#LineChartMarkerContainer_"+that.props.id).selectAll('*').remove();
      var markersCircle=d3.selectAll("#LineChartMarkerContainer_"+that.props.id)
      .selectAll("circle")
      .data(preparedData).enter()
      .append('circle')
      .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                y:yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2),
                x:xAxisScale.scale(d.xAxisValue),
                r:radius
              }
              return JSON.stringify(globalData);
      })
      .attr('cy',function(d){
        return yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2)
      })
      .attr('globalX',function(d){
        return (yAxisScale.scale(d.yAxisValue)+(yAxisScale.scale.bandwidth()/2)).toString().split(".").join("_");
      })
      .attr('cx',function(d){
        return xAxisScale.scale(d.xAxisValue)
      })
      .attr("r",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightRadius;
        }else{
        return radius;
        }
      })
      .style("stroke-width",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeWidthMarker;
        }else{
          return strokeWidthMarker;
        }
      })
      .style("stroke",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeColorMarker;
        }else{
          return strokeColorMarker;
        }
      })
      .style("fill",function(d){
        return fillColorMarker;
      })
      .attr("originalfill",function(d){
        return fillColorMarker;
      });
      
      
      markersCircle.transition().duration(300).style("fill",function(d){
        var currentFillColor=d3.select(this).style("fill");
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightColorMarker;
        }else{
          return currentFillColor;
        }
      });
     
      //CBT:THis is for tooltips 
      if(tooltip==true){
        markersCircle.on("mouseenter",(e)=>{
          // d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          d3.select(d3.event.target).transition().style("stroke",hilightStrokeColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",hilightStrokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",hilightColorMarker);
          d3.select(d3.event.target).transition().attr("r",hilightRadius);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.yAxisValue]:e.xAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircle.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.yAxisValue]:e.xAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          });
        }
        markersCircle.on("mouseout",function(d,mouseEvent){
          // d3.select(d3.event.target).transition().style("stroke-opacity",0);
          d3.select(d3.event.target).transition().style("stroke",fillColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",strokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",fillColorMarker);
          d3.select(d3.event.target).transition().attr("r",radius);
          hideDetail();
        });
      }else if(tooltip!=false && typeof(tooltip)=='object'){
        markersCircle.on("mouseenter",null);
        markersCircle.on("mouseenter",(e)=>{
           var cy=yAxisScale.scale(e.yAxisValue)+(yAxisScale.scale.bandwidth()/2);
           var cx=xAxisScale.scale(e.xAxisValue)
           showLineChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
        });
        markersCircle.on("mouseout",null);
        markersCircle.on("mouseout",function(d){
          hideLineChartTooltip();
        });
        
      }
    }
      //CBT:this is for data label
      if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabled==true){
      var format=dataLabels.format || (xAxisScale.labels && xAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefix || (xAxisScale.labels && xAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfix || (xAxisScale.labels && xAxisScale.labels.postfix) || "";
      d3.selectAll('#LineChartLabelTextContainer_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        datum=(datum!=null && typeof(datum)=='object') ? datum["data"]:datum;
        var xAxisLabels= (yAxisData[index]!=null && typeof(yAxisData[index])=='object') ? yAxisData[index]["data"]  :yAxisData[index];
        var style=$.extend({'dominant-baseline':'central'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}));
          d3.selectAll('#LineChartLabelTextContainer_'+that.props.id)
          .append('text')
          .attr("y",yAxisScale.scale(xAxisLabels)+(yAxisScale.scale.bandwidth()/2))
          .attr('x',xAxisScale.scale(datum)+radius)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix );
        })
      }
  }
  componentWillUnmount(){
    hideDetail();    
  }

  render() {
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,isGroupBar,groupIndex } = this.props
    const { height } = svgDimensions;
    var that=this;

    return (
       <g> <g
        className={'LineChartContainer_'+this.props.id}
        id={"LineChartContainer_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
      />
      <g
        id={"LineChartLabelTextContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartMarkerContainer_"+this.props.id}
        className={"LineChartMarkerContainer_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        { React.Children.count(this.props.children) ? 
        <g className="lineChartChildComponent">
          { React.Children.map(this.props.children,function(child,index){
              return (<g key={index}  className="lineChartChildComponent">{child}</g>);
            })
          }
        </g> 
        : null
        }  
        </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) {
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
    var format=tooltipStyle.format || defaultValueFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix+""+customFormat( d[data],format)+""+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor")? d3.event.x : globalData.x + $("#" + props.id).offset().left;//d3.event.x;
      d["y"] =(tooltipPosition=="cursor")? d3.event.y : globalData.y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);//,isMouseMove,isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
